import axios from 'axios'

axios.defaults.timeout = 60000

export default axios.defaults
